import { apiCall } from "../services/service";
import {
  URL_LOGO,
  URL_LOGIN,
  URL_USER,
  URL_USER_SELF,
  URL_USER_SELF_PERMISSIONS,
  URL_FORGOT_PASSWORD,
  GET_URL_RESET_PASSWORD,
  URL_ROLE_PERMISSIONS,
  URL_ALL_USERS,
  URL_UPDATE_USER_STATUS,
  URL_CREATE_USER,
  URL_UPDATE_USER,
  URL_DELETE_USER,
  URL_GET_SETTINGS,
  URL_GET_NOTIFICATION_SETTINGS,
  URL_UPDATE_NOTIFICATION_SETTINGS,
  URL_DEMO_REQUEST,
} from "./URL";

export const api = {
  logoRequest(tenantId) {
    return apiCall.get({ url: URL_LOGO, isAuthToken: false, tenantId });
  },

  loginRequest(loginParams, tenantId) {
    return apiCall.post({
      url: URL_LOGIN,
      isAuthToken: false,
      params: loginParams,
      tenantId,
    });
  },

  forgotPasswordRequest(forgotPasswordParams) {
    return apiCall.post({
      url: URL_FORGOT_PASSWORD,
      isAuthToken: false,
      params: forgotPasswordParams.payload,
      tenantId: forgotPasswordParams.domain
    });
  },

  resetPasswordRequest(resetPasswordParams) {
    return apiCall.post({
      url: GET_URL_RESET_PASSWORD(resetPasswordParams?.isForcedReset),
      isAuthToken: false,
      params: resetPasswordParams.payload,
      tenantId: resetPasswordParams.domain
    });
  },

  selfDataRequest() {
    return apiCall.get({
      url: `${URL_USER_SELF}`,
      isAuthToken: true,
    });
  },

  selfPermissionsRequest() {
    return apiCall.get({
      url: `${URL_USER_SELF_PERMISSIONS}`,
      isAuthToken: true,
    });
  },

  userDataRequest(userParams) {
    return apiCall.get({
      url: `${URL_USER}${userParams}`,
      isAuthToken: true,
      params: userParams,
    });
  },

  rolePermissionsRequest(id) {
    return apiCall.get({
      url: `${URL_ROLE_PERMISSIONS}${id}`,
      isAuthToken: true,
    });
  },

  usersRequest(params) {
    const {search, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = URL_ALL_USERS;
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  userStatusUpdateRequest(params) {
    return apiCall.patch({
      url: `${URL_UPDATE_USER_STATUS}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  userCreateRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_USER}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  userUpdateRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_USER}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  userDeleteRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_USER}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  userNotificationSettings() {
    return apiCall.get({
      url: `${URL_GET_NOTIFICATION_SETTINGS}`,
      isAuthToken: true,
    });
  },

  userSettings() {
    return apiCall.get({
      url: `${URL_GET_SETTINGS}`,
      isAuthToken: true,
    });
  },

  updateNotificationSettings(payload) {
    return apiCall.put({
      url: `${URL_UPDATE_NOTIFICATION_SETTINGS}`,
      isAuthToken: true,
      params: payload,
    });
  },

  DemoRequest(payload, headers) {
    return apiCall.post({
      url: URL_DEMO_REQUEST,
      isAuthToken: false,
      params: payload,
      headers,
    });
  },
};

export default api;
